import { observer } from 'mobx-react';
import React from 'react';
import { Footer } from 'telia-front-react';
import { getBrandLogoProps, getBrandSocialMediaItems, getBrandFooterFooter, getBrandFooterBottomLinks } from './FooterColumns';
import { DIGITARK_IDS } from './store/FooterColumnStore';
import { mapTeliaFooterColumns, getDigitarkLogoProps, filterOutDigitarkItem } from './util/FooterColumnMapper';
const FooterContainer = (props) => {
    const { brand } = props.rootStore.environmentStore;
    const isTelia = brand === 'telia';
    const footerColumns = isTelia ? mapTeliaFooterColumns(props.rootStore) : undefined;
    const socialMediaItems = getBrandSocialMediaItems(props.rootStore);
    const bottomLinks = getBrandFooterBottomLinks(props.rootStore);
    const digitarkLogoProps = getDigitarkLogoProps(socialMediaItems.find((item) => DIGITARK_IDS.includes(item.id)));
    return (React.createElement(Footer, { color: brand === 'super' ? 'neutral' : 'brand', footer: getBrandFooterFooter(props.rootStore), columns: footerColumns, socialMediaItems: filterOutDigitarkItem(socialMediaItems), bottomLinks: bottomLinks, digitalHubLogo: isTelia ? digitarkLogoProps : undefined, logo: getBrandLogoProps(props.rootStore) }));
};
export default observer(FooterContainer);
//# sourceMappingURL=FooterContainer.js.map